import styles from './TarifFilter.module.css'
import {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {FilterSortItemInt, ReduxStateInt, setSlider, setTfFilter} from "../Reducer/GlobalReducer";
import useApiQuery from "../ApiQuery/UseApiQuery";
import {SelectUnitDataInt} from "../FormTemplate/SelectUnit/SelectUnit";
import {Subscription} from "rxjs";
import {useNavigate} from "react-router-dom";

interface  ValTypeList
{
    name: string
    val?: any
    operId?:string
}



interface FilterSetInt
{
    (a:FilterInt):any
}
interface FilterPropsInt
{
    name: string;
    filter:FilterInt;
    setFilter: FilterSetInt;
}


interface FilterItemListInt
{
    [key:string]:any;
    itemId:any;
    itemChecked:boolean;
}
interface FilterInt
{
    dropped:boolean;
    filterItemList?:FilterItemListInt[]
    opOnlyOneSelect?:boolean
}

interface CbFuncInt
{
    (id:string):void
}

export default function TariffFilter()
{

    const prefDomain = useSelector((state: ReduxStateInt) => {
        return state.prefDomain
    })


    const rxObserve = useSelector((state: ReduxStateInt) => {
        return state.rxObserve
    })


    const mobileMode = useSelector((state: ReduxStateInt) => {
        return state.mobileMode
    })

    const navigate = useNavigate()
    const id = useRef<number>(Math.floor(Math.random()*100))

    const tarifTypeList = useRef()
    const [ldrTarifTypeList,rsTarifType,exTarifType] = useApiQuery("/ref/tarif/type","get",tarifTypeList);
    const [tarifTypeListData, setTarifTypeListData] = useState<SelectUnitDataInt[]>([])


    const [sortFilter, setSortFilter] = useState<FilterSortItemInt[]>([
        {
            title: "минимальная цена",
            used: false,
            id:0
        },
        {
            title: "много минут",
            used: false,
            id:1
        },
        {
            title: "много интернета",
            used: false,
            id:2
        },
    ])



    const tfFilter = useSelector((state:ReduxStateInt)  => {return state.tarifFilter} )



    const dispatch = useDispatch();

    const callBack = useRef<CbFuncInt>((ids:string)=>{
        console.log(`call back to ${ids} `,id.current)
    })

    const [operFilter, setOperFilter] = useState<FilterInt>({
        dropped:false,

    })

    const [typeFilter, setTypeFilter] = useState<FilterInt>({
        dropped:false,

    })
    const [modemFilter, setModemFilter] = useState<FilterInt>({
        dropped:false,

    })

    const [useModemList, setUseModemList] = useState<ValTypeList[]>([
        {
            name: "Да",
            val:0
        },
        {
            name: "Нет",
            val:1
        },

    ])

    const [typeList, setTypeList] = useState<ValTypeList[]>([
    ])



    const operListData = useRef()
    const [ldrOperList,rsOperList,exOperList] = useApiQuery("/ref/filter/oper","get",operListData);
    const [operList, setOperList] = useState<ValTypeList[]>([
        {
            name: "Мегафон",
            operId: "MEGAFON"
        },
        {
            name: "МТС",
            operId: "MTS"
        },
/*        {
            name: "Йота",
            operId: "YOTA"
        },
        {
            name: "Билайн",
            operId: "BEELINE"
        },
        {
            name: "Ростелеком",
            operId: "RTK"
        },*/
        {
            name: "T2",
            operId: "TELE2"
        },
        {
            name: "Билайн",
            operId: "BEELINE"
        },
    ])




    useEffect(()=>{
        loadTarifTypeList()
    },[tarifTypeList])

    useEffect(()=>{
        loadOperList()
    },[operListData])



    const loadOperList = () =>{
        exOperList().then((e)=>{
            if(e?.success && Array.isArray(e?.payload))
            {
                const x:ValTypeList[] = e?.payload?.map((item)=>{
                    return{
                        name: item?.name,
                        operId: item?.operId,

                    }
                })
                setOperList(x)
            }
        })
    }

    //Проверка на то что выбран фильтр ли в storage
    const checkSelected= (val:any , ms:any[])=>{
        if(!ms || !val) return false
        return ms.reduce((acc,vl)=>{
            if(val===vl)acc = true
            return acc
        },false)
    }


    useEffect(()=>{
        if(! tfFilter.active) resetFilter(false)
    },[tfFilter.active])

    useEffect(()=>{
        if(operList.length)setOperFilter({
            dropped:!!tfFilter?.filterOper?.length,
            opOnlyOneSelect: false,
            filterItemList: operList?.map((item)=>{
                return {...item,itemId:item.operId,itemChecked:checkSelected(item.operId, tfFilter?.filterOper)}
            })
        })

        if(typeList.length)setTypeFilter({
            dropped:!!tfFilter?.filterType?.length,
            filterItemList: typeList?.map((item)=>{
                return{...item, itemId:item.val,itemChecked:checkSelected(item.val, tfFilter?.filterType)}
            })
        })
        if(useModemList.length)setModemFilter({
            dropped:!!tfFilter?.filterTether?.length,
            filterItemList: useModemList?.map((item)=>{
                return{...item, itemId:item.val,itemChecked:checkSelected(item.val, tfFilter?.filterTether)}
            })
        })

    },[typeList,operList,useModemList])


    const loadTarifTypeList = () =>{
        exTarifType().then((e)=>{
            if(e?.success )
            {
                const aData = (e?.payload?.map((item:any)=>{
                    return                    {
                        name: item?.name,
                        val: item?.typeId

                    }
                }))
                setTarifTypeListData(aData)
                setTypeList(aData)
                return
            }
        }).catch((e)=>{
        })

    }

    const getFilterItemCheckState = (filter:FilterInt, val:any)=>{
        if(! filter?.filterItemList || val===undefined) return false;
        return filter?.filterItemList.reduce((acc:boolean, item:FilterItemListInt)=>{
            if(item.itemId === val) acc = item.itemChecked
            return acc
        }, false)
    }
    const setFilterItemCheckState = (filter:FilterInt, setFilter:any, val:any, checked:boolean)=>{
        if(! filter?.filterItemList || val===undefined || !setFilter) return ;
        setFilter(  {...filter, itemList: filter.filterItemList.map((item=>{
            if(item.itemId === val) item.itemChecked = checked
            if(item.itemId !== val && filter?.opOnlyOneSelect) item.itemChecked = false
            //console.log("item", item)
            return item
        }))})
    }



    const buildFilter = ({filter,setFilter,name}:FilterPropsInt)=>{
//        const buildFilter = (name:string, filterItemList:FilterInt, setFilterItemList: any)=>{
        if(! filter?.filterItemList) return  null
        return(
            <div className={styles.tfBlock}>
                <div className={styles.tfHead}
                     onClick={()=>{
                         const dropped = filter.dropped
                         setFilter({...filter,dropped: !dropped})
                     }}>
                    <i className={['bx bxs-chevron-down arrow',styles.blockArrow, filter.dropped ? styles.dropped:"" ].join(' ')}></i>
                    <span>{name}</span>
                </div>
                <hr className={styles.hrBlock}></hr>
                <div className={[styles.itemContainer, filter.dropped ? "" :"d-none" ].join(' ')}>
                    {filter.filterItemList?.map((item, key)=>{
                        const checked = getFilterItemCheckState(filter,item.itemId)
                        //console.log("getCheckState ", checked, item.val)
                        return (
                            <form key={key}>
                                <div className={styles.tfItem}
                                onClick={()=>{setFilterItemCheckState(filter, setFilter,item.itemId,!checked)}}
                                >
                                    <input className={["form-check-input", styles.itemCheckBox].join(' ')} type={"checkbox"}
                                    checked={checked}
                                    onChange={()=>{}}
                                    ></input>
                                    {item?.name}
                                </div>
                            </form>
                        )
                    })}
                </div>
            </div>
        )
    }

    const getFilterValue = (filter:FilterInt)=>
    {
        if(filter.filterItemList && filter.filterItemList?.length ===0 )return [];
        const rs:any[]=[]
        let checkCount = 0
        filter.filterItemList?.map((item)=>{
            if(item.itemChecked){  rs.push(item.itemId); checkCount++}
        })
        if(checkCount===0 || checkCount === filter.filterItemList?.length ) return []
        return rs;
    }

    const resetFilterValue = (filter:FilterInt, setFilter:any)=>
    {
        const itemList = filter.filterItemList?.map((item)=>{item.itemChecked = false; return item})
        setFilter({...filter,
            itemList: itemList, dropped:false

        })


    }

    const makeFilter = ()=>{
        const operFilterValue = getFilterValue(operFilter);
        const modemFilterValue = getFilterValue(modemFilter);
        const typeFilterValue = getFilterValue(typeFilter);
        dispatch(setTfFilter({
            ...tfFilter,
            appliedFilter: true,
            active: true,
            filterOper: operFilterValue,
            filterTether: modemFilterValue,
            filterType: typeFilterValue,
            sort: sortFilter?.filter((item)=>item.used),
            id: id.current

        }))

        rxObserve.next({
            message: "tFilter-make",
            data: {
                filterOper: operFilterValue,
                filterTether: modemFilterValue,
                filterType: typeFilterValue,
                sort: sortFilter?.filter((item)=>item.used),
                id: id.current
            }
        })

        if(mobileMode)rxObserve.next({
            message:"slider-view"
        })




        //console.log(operFilterValue,modemFilterValue,typeFilterValue)
    }
    const resetFilter = (hide:boolean)=>{
        resetFilterValue(operFilter, setOperFilter)
        resetFilterValue(modemFilter, setModemFilter)
        resetFilterValue(typeFilter, setTypeFilter)

        setSortFilter(
            sortFilter.map((item)=>{
                item.used = false
                return item
            })
        )

        dispatch(setTfFilter({
            ...tfFilter,
            active: hide,
            appliedFilter: false,
            filterOper: [],
            filterTether: [],
            filterType: [],
            sort: [],
            id: id.current

        }))
        rxObserve.next({
            message: "tFilter-reset",
            data: {
                id: id.current
            }
        })
        if(mobileMode && hide)rxObserve.next({
            message:"slider-view"
        })



        //navigate('/')


    }

    const closeFilter = (hide:boolean) =>{
        resetFilter(hide)
    }


    const handleSortItem = (id:number) =>{
        const x = sortFilter.map((item,idx)=>{

            if(idx === id)item.used = !item.used
            else item.used = false
            return item
        })
        setSortFilter(x)
    }
    const buildSort = ()=>{
        return sortFilter?.map((item,idx)=>{
            return(
                <div key={idx} className={[styles.sortItem, item?.used ? styles.sortItemActive : ""].join(' ')}
                    onClick={()=>handleSortItem(idx)}
                >
                    {item?.title}
                </div>
            )
        })
    }

//    if(!domainPref.showMainFilter)return null
    //console.log(`Build tFilter ${id.current}`)
    if(! tfFilter.active) return null
    return(

                <div className={styles.tfListContainer}>
                    <div className={styles.tfList}>
                        <div className={styles.fltCont}>
                            <div className={styles.blockTitle}>Фильтры</div>
                            <hr className={styles.hrBlock}></hr>
                            {buildFilter({name:"Оператор",filter:operFilter, setFilter:setOperFilter})}
                            {buildFilter({name:"Назначение sim карты",filter:typeFilter, setFilter:setTypeFilter})}
                            { false && buildFilter({name:"Работа на раздачу",filter:modemFilter, setFilter:setModemFilter})}
                        </div>
                        <div className={styles.fltCont}>
                            <div className={styles.blockTitle}>Сортировки</div>
                            <hr className={styles.hrBlock}></hr>
                            <div className={styles.sortCont}>
                                {buildSort()}
                            </div>
                            <hr className={styles.hrBlock}></hr>
                        </div>
                        <div className={styles.btContainer}>
                            <div className={styles.btn} onClick={()=>makeFilter()}>Применить</div>
                            <div className={styles.btn} onClick={()=>resetFilter(true)}>Сбросить</div>
                            <div className={styles.btn} onClick={()=>closeFilter(false)}>Закрыть</div>
                        </div>
                    </div>
                </div>


    )
}